import { createContext } from 'react';
export const FormOptionCardContext = createContext({
    componentNameGA: 'form-option-card',
    dataTest: 'form-option-card',
    inputType: 'radio',
    name: 'form-option-card',
    onChange: undefined,
    required: false,
    textValidationMessages: undefined,
});
